import initialState from "./initialState";

export function CourseReducer(state = initialState.courseParams, action) {
  switch (action.type) {
    case "SEARCH_COURSE_SET":
      return action.payload;
    default:
      return state;
  }
}
